<template>
  <div>
    <p style="color: #fff; margin: 0">
      {{i18n.global.t("tost_message.varify_acc")}}
    </p>
    <a style="color: rgb(119, 6, 6)" href="javascript:void(0);">
      {{i18n.global.t("tost_message.click_to_begin")}}
    </a>
  </div>
</template>
<script>
  import i18n from '@/components/shared/i18n';
  export default{
    data(){
      return {
        i18n
      }
    }
  }
</script>
